import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs';
import {environment} from '../../../environments/environment';
import {OverlayElement} from '../interfaces/overlay-element.interface';

@Injectable({providedIn: 'root'})
export class OverlayElementResource {
  private readonly baseUrl = environment.apiUrl;

  constructor(private http: HttpClient) {
  }

  getAllForMap(mapId: string): Observable<OverlayElement[]> {
    return this.http.get<OverlayElement[]>(`${this.baseUrl}/overlay-elements/map/${mapId}`);
  }

  getOne(id: string): Observable<OverlayElement> {
    return this.http.get<OverlayElement>(`${this.baseUrl}/overlay-elements/${id}`);
  }

  create(element: OverlayElement): Observable<OverlayElement> {
    return this.http.post<OverlayElement>(`${this.baseUrl}/overlay-elements`, element);
  }

  update(element: OverlayElement): Observable<OverlayElement> {
    return this.http.put<OverlayElement>(`${this.baseUrl}/overlay-elements`, element);
  }

  updatePosition(id: string, x: number, y: number, stateId?: string): Observable<OverlayElement> {
    return this.http.put<OverlayElement>(`${this.baseUrl}/overlay-elements/position`, {id, x, y, stateId});
  }

  multiUpdate(elements: Partial<OverlayElement>[]): Observable<OverlayElement[]> {
    return this.http.put<OverlayElement[]>(`${this.baseUrl}/overlay-elements/multi-update`, elements);
  }

  resetElement(id: string, stateId: string): Observable<OverlayElement> {
    return this.http.put<OverlayElement>(`${this.baseUrl}/overlay-elements/reset`, {id, stateId});
  }

  delete(id: string): Observable<any> {
    return this.http.delete(`${this.baseUrl}/overlay-elements/${id}`);
  }

  restore(id: string): Observable<OverlayElement> {
    return this.http.put<OverlayElement>(`${this.baseUrl}/overlay-elements/restore/${id}`, {});
  }

  batchRestore(ids: string[]): Observable<OverlayElement[]> {
    return this.http.put<OverlayElement[]>(`${this.baseUrl}/overlay-elements/restore-batch`, {ids});
  }
}
